import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpGet, httpPost } from "../../services/httpService";
import {
  getAllDocumentsServiceUrl,
  documentSaveUrl,
  getDocumentById,
  generateAiQuestionairesUrl,
  addorUpdateDocumentQuestionsUrl,
  UpdateDocumentcomplienceStatusUrl,
  getAllDocumentsByEmailUrl,
  updateDocumentAssignmentsUrl,
  UpdateMultipleDocumentcomplienceStatusUrl,
} from "../../apiUrls/apiUrls";
import { logErrorWithPayload } from "../../services/logService";

const initialState = {
  isDocumentLoading: false,
  documentsData: [],
  currentDocumentData: [],
  currentDocumentId: "0",
  currentDocumentName: "",
  lastDocumentAddedUpdated: null,
  documentById: [],
  isdocumentQuestionsLoading: false,
  documentQuestions: [],
  isAiQuestionsGeneratingLoading: false,
  viewingDoc: null,
  isUpdateDocumentcomplienceStatusLoading: false,
  myDocumentsData: [],
  myDocumentsLoading: false,
  isUpdateDocumentAssignmentsLoading: false,
  isUpdateMultipleDocumentcomplienceStatusLoading: false,
  folder: null,
};

export const getAllDocumentsData = createAsyncThunk(
  "document/getAllDocumentsData",
  async (params) => {
    const { pharmacyId, serviceId } = params;
    const urlToGet = getAllDocumentsServiceUrl(pharmacyId, serviceId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const addDocumentData = createAsyncThunk(
  "document/addDocumentData",
  async (data, thunkAPI) => {
    const respData = await httpPost(documentSaveUrl(), data);
    return respData;
  },
);

export const getDocumenteByIdData = createAsyncThunk(
  "document/getDocumenteByIdData",
  async (documentId, thunkAPI) => {
    const respData = await httpGet(getDocumentById(documentId));
    return respData;
  },
);
export const generateAiQuestionairesData = createAsyncThunk(
  "document/generateAiQuestionairesData",
  async (params, thunkAPI) => {
    const respData = await httpPost(generateAiQuestionairesUrl(), params);
    return respData;
  },
);
export const addorUpdateDocumentQuestionsData = createAsyncThunk(
  "document/addorUpdateDocumentQuestionsData",
  async (params, thunkAPI) => {
    const respData = await httpPost(addorUpdateDocumentQuestionsUrl(), params);
    return respData;
  },
);
export const updateDocumentcomplienceStatusData = createAsyncThunk(
  "document/updateDocumentcomplienceStatusData",
  async (params, thunkAPI) => {
    const respData = await httpPost(
      UpdateDocumentcomplienceStatusUrl(),
      params,
    );
    return respData;
  },
);

export const getAllDocumentsByEmailData = createAsyncThunk(
  "document/getAllDocumentsByEmailData",
  async (params) => {
    const urlToGet = getAllDocumentsByEmailUrl();
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const updateDocumentAssignmentsData = createAsyncThunk(
  "document/updateDocumentAssignmentsData",
  async (params, thunkAPI) => {
    const respData = await httpPost(updateDocumentAssignmentsUrl(), params);
    return respData;
  },
);
export const UpdateMultipleDocumentcomplienceStatusData = createAsyncThunk(
  "document/UpdateMultipleDocumentcomplienceStatusData",
  async (params, thunkAPI) => {
    const respData = await httpPost(
      UpdateMultipleDocumentcomplienceStatusUrl(),
      params,
    );
    return respData;
  },
);

export const documentServiceSlice = createSlice({
  name: "document",
  initialState,
  reducers: {
    setIsDocumentLoading: (state, action) => {
      state.isDocumentLoading = action?.payload || false;
    },
    setDocumentID: (state, action) => {
      state.currentDocumentId = action?.payload || "0";
    },
    setDocumentName: (state, action) => {
      state.currentDocumentName = action?.payload || "";
    },
    setDocumentData: (state, action) => {
      state.documentsData = action?.payload || [];
    },
    setViewingDocData: (state, action) => {
      state.viewingDoc = action?.payload || [];
    },
    setFolderData: (state, action) => {
      state.folder = action?.payload || null;
    },
    resetDocumentState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllDocumentsData.pending, (state) => {
        state.isDocumentLoading = true;
      })
      .addCase(getAllDocumentsData.fulfilled, (state, action) => {
        state.isDocumentLoading = false;
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse) {
          try {
            state.documentsData = appDataFromResponse || [];
          } catch (error) {}
        }
      })
      .addCase(getAllDocumentsData.rejected, (state, action) => {
        state.isDocumentLoading = false;
        state.documentsData = [];
      })
      .addCase(addDocumentData.pending, (state) => {
        state.isDocumentLoading = true;
        state.lastDocumentAddedUpdated = null;
      })
      .addCase(addDocumentData.fulfilled, (state, action) => {
        state.isDocumentLoading = false;
        state.lastDocumentAddedUpdated = action?.payload;
      })
      .addCase(addDocumentData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isDocumentLoading = false;
        state.lastDocumentAddedUpdated = null;
      })
      .addCase(getDocumenteByIdData.pending, (state) => {
        state.isDocumentLoading = true;
        state.documentById = [];
      })
      .addCase(getDocumenteByIdData.fulfilled, (state, action) => {
        state.isDocumentLoading = false;
        state.documentById = action?.payload || [];
      })
      .addCase(getDocumenteByIdData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isDocumentLoading = false;
        state.documentById = [];
      })
      .addCase(addorUpdateDocumentQuestionsData.pending, (state) => {
        state.isdocumentQuestionsLoading = true;
      })
      .addCase(addorUpdateDocumentQuestionsData.fulfilled, (state, action) => {
        state.isdocumentQuestionsLoading = false;
      })
      .addCase(addorUpdateDocumentQuestionsData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isdocumentQuestionsLoading = false;
      })
      .addCase(generateAiQuestionairesData.pending, (state) => {
        state.isAiQuestionsGeneratingLoading = true;
      })
      .addCase(generateAiQuestionairesData.fulfilled, (state, action) => {
        state.isAiQuestionsGeneratingLoading = false;
        state.documentQuestions = action?.payload || [];
      })
      .addCase(generateAiQuestionairesData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isAiQuestionsGeneratingLoading = false;
      })
      .addCase(updateDocumentcomplienceStatusData.pending, (state) => {
        state.isUpdateDocumentcomplienceStatusLoading = true;
      })
      .addCase(
        updateDocumentcomplienceStatusData.fulfilled,
        (state, action) => {
          state.isUpdateDocumentcomplienceStatusLoading = false;
        },
      )
      .addCase(updateDocumentcomplienceStatusData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isUpdateDocumentcomplienceStatusLoading = false;
      })
      .addCase(getAllDocumentsByEmailData.pending, (state) => {
        state.myDocumentsLoading = true;
      })
      .addCase(getAllDocumentsByEmailData.fulfilled, (state, action) => {
        state.myDocumentsLoading = false;
        state.myDocumentsData = action?.payload;
      })
      .addCase(getAllDocumentsByEmailData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.myDocumentsLoading = false;
        state.myDocumentsData = [];
      })
      .addCase(updateDocumentAssignmentsData.pending, (state) => {
        state.isUpdateDocumentAssignmentsLoading = true;
      })
      .addCase(updateDocumentAssignmentsData.fulfilled, (state, action) => {
        state.isUpdateDocumentAssignmentsLoading = false;
      })
      .addCase(updateDocumentAssignmentsData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isUpdateDocumentAssignmentsLoading = false;
      })
      .addCase(UpdateMultipleDocumentcomplienceStatusData.pending, (state) => {
        state.isUpdateMultipleDocumentcomplienceStatusLoading = true;
      })
      .addCase(
        UpdateMultipleDocumentcomplienceStatusData.fulfilled,
        (state, action) => {
          state.isUpdateMultipleDocumentcomplienceStatusLoading = false;
        },
      )
      .addCase(
        UpdateMultipleDocumentcomplienceStatusData.rejected,
        (state, action) => {
          logErrorWithPayload(action?.error);
          state.isUpdateMultipleDocumentcomplienceStatusLoading = false;
        },
      );
  },
});

// Action creators are generated for each case reducer function
export const {
  setIsDocumentLoading,
  setDocumentID,
  setDocumentName,
  setDocumentData,
  resetDocumentState,
  setViewingDocData,
  setFolderData,
} = documentServiceSlice.actions;

export default documentServiceSlice.reducer;
